<template>
    <div>
        <swb-query-sort-area v-if="showQuery" ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcCategApi from '../../api/servcCateg'
    import servcDelivApi from '../../api/servcDeliv'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "派工单号",
                "code": "no",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "买家公司名称",
                "code": "buyerName",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "买家机构名称",
                "code": "buyerShopName",
                "basic": true
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "主工程师",
                "code": "engineerName",
                "basic": true
            },
            {
                "type": "Select",
                "valueType": "Integer",
                "label": "紧急状态",
                "basic": true,
                "code": "emgLevel",
                "dataLabel": "text",
                "dataValue": "code",
                "dataList": [
                    {
                        "code": null,
                        "text": "全部"
                    },
                    {
                        "code": "0",
                        "text": "一般"
                    },
                    {
                        "code": "1",
                        "text": "紧急"
                    },
                    {
                        "code": "2",
                        "text": "特急"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "状态",
                "code": "state",
                "valueType": 'Integer',
                "basic": true,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "16",
                        "label": "待指派网点"
                    },
                    {
                        "value": "15",
                        "label": "待派工"
                    },
                    {
                        "value": "3",
                        "label": "待出发"
                    },
                    {
                        "value": "4",
                        "label": "已出发"
                    },
                    {
                        "value": "5",
                        "label": "已到达"
                    },
                    {
                        "value": "6",
                        "label": "服务中"
                    },
                    {
                        "value": "7",
                        "label": "服务暂停"
                    },
                    {
                        "value": "9",
                        "label": "服务完成"
                    },
                    {
                        "value": "10",
                        "label": "验收完成"
                    },
                    {
                        "value": "12",
                        "label": "已支援"
                    },
                    {
                        "value": "13",
                        "label": "已作废"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "是否已评价",
                "code": "evalFlag",
                "valueType": 'Boolean',
                "basic": true,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "已关闭",
                "code": "closed",
                "valueType": 'Boolean',
                "basic": true,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ],
                "value": "false"
            },
            {
                "type": "Select",
                "label": "工单类型",
                "code": "servcType",
                "valueType": 'Integer',
                "basic": false,
                "dataList": []
            },
            {
                "type": "Select",
                "label": "服务分类",
                "code": "catId",
                "valueType": 'Integer',
                "basic": false,
                "dataList": [],
            },
            {
                "type": "Select",
                "label": "是否来源于订单",
                "code": "orderFlag",
                "valueType": 'Boolean',
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ],
            },
            {
                "type": "Select",
                "label": "约定期保外",
                "code": "beyondWrnt",
                "valueType": 'Boolean',
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ],
            },
            {
                "type": "Select",
                "label": "未生成交易单",
                "code": "noneTrade",
                "valueType": 'Boolean',
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ],
            },
            {
                "type": "Select",
                "label": "业务标签",
                "code": "servicerTag",
                "valueType": 'String',
                "basic": false,
                "dataList": []
            },
            {
                "type": "Text",
                "valueType": "String",
                "label": "授权公司名称",
                "code": "srcVendorName",
                "basic": false
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "创建时间",
                "code": "createTime",
                "basic": false
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "预约上门日期",
                "code": "planTime",
                "basic": false
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "计划出发日期",
                "code": "planStartOffTime",
                "basic": false
            },
            {
                "type": "Checkbox",
                "valueType": "Boolean",
                "label": "保养完成超期",
                "code": "maintTimeOutFlag",
                "dataLabel": "text",
                "dataValue": "code",
                "basic": false
            },
            {
                "type": "Select",
                "label": "是否远程解决",
                "code": "remoted",
                "valueType": 'Boolean',
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "指派网点",
                "code": "manualShopFlag",
                "valueType": 'Boolean',
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "手工"
                    },
                    {
                        "value": "false",
                        "label": "自动"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "指派工程师",
                "code": "manualEngFlag",
                "valueType": 'Boolean',
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "手工"
                    },
                    {
                        "value": "false",
                        "label": "自动"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "绩效标记",
                "code": "performFlag",
                "valueType": 'Integer',
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "0",
                        "label": "无"
                    },
                    {
                        "value": "1",
                        "label": "保底"
                    },
                    {
                        "value": "2",
                        "label": "计件"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "工单模式",
                "code": "grabFlag",
                "valueType": 'Boolean',
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "抢单"
                    },
                    {
                        "value": "false",
                        "label": "指派"
                    }
                ]
            }
        ],
        "sortFields": [
            {
                "label": "预约上门日期",
                "code": "planTime",
                "order": "desc",
                "enabled": true
            },
            {
                "label": "计划出发日期",
                "code": "planStartOffTime",
                "order": "desc"
            }
        ]
    };

    export default {
        name: 'swb-servc-work-voucher-search',
        desc: '派工单列表搜索',
        props: {
            no: {
                type: String,
                default: null
            }
        },
        data: function () {
            return {
                //排序、搜索
                queryConfig: null,
                queryKey: null,
                showQuery: true
            }
        },
        created: function () {
            this.getMerchtFusedServcCat();
        },
        methods: {
            getMerchtFusedServcCat: function () {
                let self = this;

                self.showQuery = false;
                servcCategApi.getMerchtFusedServcCatListByMerchantId({}, function (result) {
                    if(result.type == "info") {
                        let rows = result.data;
                        let queryConfig = searchConfigData || {};
                        let queryConfigMap = queryConfig.queryFields.toMap("code");
                        let catList = [];
                        if(rows != null && rows.length > 0) {
                            rows.forEach(function (item) {
                                let cat = {};
                                cat.value = item.catId;
                                cat.label = item.catName;
                                catList.push(cat);
                            });
                        }
                        let catListItem = queryConfigMap["catId"];
                        catListItem.dataList = [];
                        catListItem.dataList = Utils.merge([], catList);
                        self.queryConfig = Utils.merge({}, queryConfig);
                        self.initQuery();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            initQuery: function () {
                let self = this;
                let servicerTagList = [{
                    value: null,
                    label: '- 全部 -'
                }];
                let servicerTags = null;
                let postData = {};
                servcDelivApi.getServcWorkVoucherServicerTagList(postData, function (result) {
                    if(result.type === "info") {
                        servicerTags = result.data;
                        if(servicerTags != null && servicerTags.length > 0) {
                            servicerTags.forEach(function (item) {
                                let queryItem = {};
                                queryItem.value = item;
                                queryItem.label = item;
                                servicerTagList.push(queryItem);
                            });
                        }
                        let queryConfig = self.queryConfig || {};
                        let queryConfigMap = queryConfig.queryFields.toMap("code");
                        //
                        let servicerTagListItem = queryConfigMap["servicerTag"];
                        servicerTagListItem.dataList = [];
                        servicerTagListItem.dataList = Utils.merge([], servicerTagList);
                        //
                        let noItem = queryConfigMap['no'];
                        noItem.value = self.no;
                        let workServcTypeList = [{
                            value: null,
                            label: '- 全部 -'
                        }];
                        let workServcTypes = getEnumList("workServcType");
                        if(workServcTypes != null && workServcTypes.length > 0) {
                            workServcTypes.forEach(function (item) {
                                let queryItem = {};
                                queryItem.value = item.value;
                                queryItem.label = item.text;
                                workServcTypeList.push(queryItem);
                            });
                        }
                        let workServcTypeListItem = queryConfigMap["servcType"];
                        workServcTypeListItem.dataList = [];
                        workServcTypeListItem.dataList = Utils.merge([], workServcTypeList);
                        //
                        self.queryConfig = Utils.merge({}, queryConfig);
                        self.showQuery = true;
                    } else {
                        MsgBox.warning(result.message);
                    }

                });




            },
            //
            queryHandler(queryModel) {
                //缓存查询条件
                this.$emit('showSearch', queryModel);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherSearch.vue